module.exports = __webpack_public_path__ + "img/stock0.c9b64c00.png";